import { render, staticRenderFns } from "./vue-gantt-lazy.vue?vue&type=template&id=37d41833"
import script from "./vue-gantt-lazy.vue?vue&type=script&lang=js"
export * from "./vue-gantt-lazy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports